"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authCrmDetailApi = authCrmDetailApi;
exports.authCrmRedirectApi = authCrmRedirectApi;
exports.authGetUserLatestDetailApi = authGetUserLatestDetailApi;
exports.authLoginApi = authLoginApi;
exports.authLogoutApi = authLogoutApi;
exports.authProfileApi = authProfileApi;
exports.authRefreshTokenApi = authRefreshTokenApi;
exports.authSSOTokenApi = authSSOTokenApi;
var _core = require("../../core/core.service");
var _app = _interopRequireWildcard(require("../../../configs/app.config"));
var _dashboard = require("../../../constants/endpoints/dashboard");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// @flow

var api = new _core.APICore();

/**
 * Login
 * @param payload
 * @returns api response
 * @description this function used to user login by its credencials.
 */
function authLoginApi(params) {
  (0, _app.setConfigUrl)();
  return api.create("".concat(_app.default.baseUrl + _dashboard.GatewayService.authenticate), params);
}

/**
 * Logout
 * @returns api response
 * @description this function used to user logout.
 */
function authLogoutApi() {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.UserService.authenticate.logout));
}

/**
 * Refresh Token
 * @param payload
 * @returns api response
 * @description this function used to refresh the existing access token.
 */
function authRefreshTokenApi() {
  var user = (0, _core.getUserFromSession)();
  return api.get("".concat(_app.default.baseUrl + _dashboard.GatewayService.refreshToken + user.refreshToken));
}

/**
 * Refresh Token
 * @param payload
 * @returns api response
 * @description this function used to refresh the existing access token.
 */
function authSSOTokenApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.GatewayService.ssoToken + params));
}

/*
 * logged in user details
 * @param payload
 * @returns api response
 * @description this function used to get logged in user's details.
 */
function authProfileApi() {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.root.getUser));
}

/*
 * logged in user details
 * @param payload
 * @returns api response
 * @description this function used to get logged in user's details.
 */
function authGetUserLatestDetailApi() {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.root.userLatestDetail));
}

/*
 * crm detail
 * @param payload
 * @returns api response
 * @description this function used to get crm details.
 */
function authCrmDetailApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.crm.detail), params);
}

/*
 * crm redirect
 * @param payload
 * @returns api response
 * @description this function used to crm redirect.
 */
function authCrmRedirectApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.crm.redirect), params);
}